
                            const chunks = `/// #replace #define SIXTY_UNIFORMS_AREA
#define SIXTY_UNIFORMS_AREA

uniform sampler2D tFabricNormal;
uniform float uDarkMode;
varying vec3 vPosition;


/// #replace #define SIXTY_NORMALMAP_AREA
#define SIXTY_NORMALMAP_AREA

// Fabric Normal
tbn = getTangentFrame(-vViewPosition, normal, vNormalMapUv);

vec3 nTex2 = texture2D(tFabricNormal, vNormalMapUv * 5.).rgb * 2. - 1.;
// diffuseColor.rgb = nTex2;
nTex2.xy *= 2.5;

normal = normalize(tbn * nTex2);
normal.x -= uDarkMode * .5;

// roughness *= 0.8;


/// #replace vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
outgoingLight *= min(1. + 0.8 * faceDirection, 1.);

/// #replace #define SIXTY_END_AREA
gl_FragColor.rgb = mix(gl_FragColor.rgb, gl_FragColor.rgb * gl_FragColor.rgb * .4, uDarkMode);`;

                            function replace(chunksCode = '', defaultShader = '') {
                                const chunks = parseCode(chunksCode);
                                chunks.forEach(({ target, replace }) => {
                                    defaultShader = defaultShader.replace(target, replace);
                                });

                                return defaultShader;
                            }

                            function parseCode(code, pattern = '/// #replace') {
                                const replacements = [];
                                const lines = code.trim().split('\n');

                                for (let i = 0; i < lines.length; i++) {
                                    const line = lines[i].trim();
                                    if (line.startsWith(pattern)) {
                                        const target = line.replace(pattern, '');
                                        const replaceLines = [];
                                        let j = i + 1;

                                        while (j < lines.length && !lines[j].trim().startsWith(pattern)) {
                                            const nextLine = lines[j].trim();
                                            if (nextLine) {
                                                replaceLines.push(nextLine);
                                            }
                                            j++;
                                        }

                                        const replace = replaceLines.join('\n');
                                        replacements.push({ target: target.trim(), replace: replace.trim() });

                                        i = j - 1;
                                    }
                                }
                                return replacements;
                            }

                            export default {
                                use: (el) => {
                                    const instance = el.material || el;
                                    instance['fragmentShader'] = replace(chunks, instance['fragmentShader']);
                                    instance.needsUpdate = true;
                                    return el;
                                }
                            }
                        